module.exports = __webpack_public_path__ + "static/creej-1ebb0e17601d34243b1a9f67ee392eda.png";